import React from "react"
import ReactDOM from "react-dom/client"

import App from "./App"
import { AuthWrapper } from "./context/AuthWrapper"

import "./index.css"

const rootElement = document.getElementById("root")
if (!rootElement) throw new Error("Root element not found")

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AuthWrapper>
      <App />
    </AuthWrapper>
  </React.StrictMode>,
)
